import styled from 'styled-components'
import { colors } from 'Styled/variables'

export const PageTitle = styled.h3`
  margin-bottom: 26px;
  color: ${colors.mainText};
  font-weight: 600;
  font-size: 20px;
  line-height: 30px;
  @media (min-width: 576px) {
    margin-bottom: 24px;
    padding-left: 15px;
  }
`

export const PageContent = styled.div``
